module.exports = __webpack_public_path__ + "static/media/2.definitions.24eedad1.png";